export default __webpack_public_path__ + "static/thebottomline8-87cecef960dbe47fabb0e2f70c933600.jpg";